import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEComment } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComment';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseComment } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComment';
import { APPComment } from '../../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComment';
import { ProductComment } from '../../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComment';
import { RectShape } from '../../BaseShape/RectShape';
import { ShapeModel } from '../../BaseShape/ShapeModel';

/** 备注的图形 */
export class JointCommentShape extends RectShape {
  /** 重写超类属性 */
  defaults() {
    return {
      ...super.defaults,
      // 定义图形的实际类型
      type: 'mst.JointCommentShape',
      attrs: {
        rect: { 'stroke-width': 0, fill: '#FFFFFF' },
        '.uml-comment-container': { fill: '#ffffc0', strokeWidth: 2, stroke: '#545c64', cursor: 'move' },
        '.uml-comment-text': { fontSize: 12 }
      },
      position: { x: 10, y: 10 }
    };
  }

  /**
   * 反序列化构造器，由joint框架默认调用。
   * 1、重写属性
   * 2、设置自定义属性
   * 3、自定义属性反序列化的自行处理
   * @param attributes 从JSON构造
   * @param opt 图形
   */
  constructor(attributes?: any, opt?: any) {
    // 调用超类的构造器
    super(attributes, opt);
    // 重写图形，如果放在defaults上面会覆盖超类，这里只会修改不一致的项，Very Important
    this.attr({
      body: { fill: '#ffffc0', stroke: '#545c64' },
      label: {
        fill: '#000000',
        fontSize: 12
      }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  /**
   * 设置元数据，手工创建图形的时候要额外调用
   * @param commentShape 注释的图形
   * @param comment 注释
   * @param isFromJSON 是否通过JOINT的JSON构造，这种情况不能从元数据取值
   */
  public setMD(elementShape: NodeShape, element: BaseComment, isFromJSON: boolean) {
    this.setBaseMD(elementShape, new ShapeModel(element, false), isFromJSON);
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointCommentShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    let newElement = null;
    if (this.comment instanceof BEComment) {
      newElement = new BEComment();
    } else if (this.comment instanceof APPComment) {
      newElement = new APPComment();
    } else if (this.comment instanceof ProductComment) {
      newElement = new ProductComment();
    }

    (newElement as BaseComment).copyFrom(this.comment, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.comments.push(newElement as BEComment);
    }

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  get comment(): BaseComment {
    return this.element() as BaseComment;
  }

  get commentShape(): NodeShape {
    return this.shape();
  }

  shapeType(): string {
    return MDAConstant.Type.ADD_BECOMMENT;
  }

  doAction(action: string): BaseElement | null {
    return super.doAction(action);
  }

  /** 校验模型 */
  public validate(): Array<ValidationResult> {
    return super.validate();
  }

  /** 添加子元素的克隆 */
  addChildClone(element: BaseElement, elements: Array<BaseElement>): BaseElement | null {
    return null;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType !== '') {
      this.attr({ '.uml-comment-container': { cursor: 'not-allowed' }, '.uml-comment-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-comment-container': { cursor: 'move' }, '.uml-comment-text': { cursor: 'move' } });
    }
  }

  /** 输出图形的代码 */
  protected updateRectangles(setWidth?: number, setHeight?: number) {
    const model = this.get('model') as ShapeModel;
    if (model == null) {
      return;
    }
    let height = this.size().height;
    if (setHeight) {
      height = setHeight;
    } else if (height === 0) {
      height = 40;
    }
    let width = this.size().width;
    if (setWidth) {
      width = setWidth;
    } else if (width === 0) {
      width = ((model.element as BaseComment).text.length + 2) / 3 * 16;
      if (width < 180) {
        width = 180;
      }
    }
    const markup: Array<string> = new Array<string>();
    markup.push('<g>');
    markup.push(`<rect class="uml-comment-container" rx="5" ry="5" width="${width}" height="${height}"/>`);
    markup.push(`<foreignObject class="uml-comment-text" style="text-align:left;color:black" width="${width - 10}" height="${height - 10}" transform="translate(5, 5)">${(model.element as BaseComment).text}</foreignObject >`);
    // markup.push(`<div style="display:none">${model.element.description}</div>`);
    markup.push('</g>');
    this.set('markup', markup.join(''));
    this.size(width, height);
    this.trigger('uml-update');
  }
}
